import Heading from '@totallymoney/ui/components/Heading'
import Text from '@totallymoney/ui/components/Text'

const ContentGuarantor = () => {
    return (
        <>
            <Heading variant="100" as="h1">
                Frequently Asked Questions
            </Heading>
            <Heading variant="60" as="h2">
                Q. What’s a guarantor loan?
            </Heading>
            <Text>
                It’s a loan where someone — a guarantor — agrees to cover you if
                you can’t make a payment. They’re there for those who find it
                harder to get personal loans, as having a guarantor gives
                lenders confidence they’re likely to get their money back.
            </Text>
            <Heading variant="60" as="h2">
                Q. How do they work?
            </Heading>
            <Text>
                First, lenders will do a ‘soft search’ on you and your guarantor
                to decide whether to accept you or not. Don’t worry, this search
                won’t harm your credit rating. And, you’ll both need to show you
                have a regular income — just as a way to make lenders confident
                they’ll get the money back.It’s up to you to make the monthly
                repayments to pay off the loan. But, to help stop fraud, the
                loan amount is usually be paid to the guarantor. So, you need to
                trust your guarantor will send the funds straight over to you.
                If a payment is late or missed, the lender will tell your
                guarantor, to keep them in the loop with what’s happening. And,
                if you can’t make a payment, the lender will go to them to get
                it. If they can’t make the payment, they may face legal action.
                It’ll also appear on their credit file and could harm their
                credit score — not great if you’re close to your guarantor.
                Missed payments also harm your credit rating and will make it
                harder to be accepted for the credit you want in the future.
            </Text>
            <Heading variant="60" as="h2">
                Q. Who can be guarantor?
            </Heading>
            <Text>
                Most importantly, it needs to be someone who can help you pay
                the loan. It should ideally be someone you trust, like a
                relative or close friend — but normally a spouse or partner
                isn’t allowed. They usually have to be under 75 years old, too.
                It helps as well if your guarantor is a homeowner. It shows
                they’re a bit more secure, so you’re more likely to be accepted
                for the loan — and at a lower rate. That’s great, as you’ll pay
                less interest every month.
            </Text>
            <Heading variant="60" as="h2">
                Q. What is compared?
            </Heading>
            <Text>
                We compare a wide range of guarantor loans from across the
                market, to give you the best choice possible — so you can choose
                the one that works best for you.
            </Text>
            <Heading variant="60" as="h2">
                Q. What happens next?
            </Heading>
            <Text>
                If you want to apply for a loan, hit the orange button, and
                we’ll send you straight to the lender’s site to finish things
                up.
            </Text>
            <Heading variant="60" as="h2">
                Q. What’s pre-population?
            </Heading>
            <Text>
                Pre-pop (as we call it) is when all the details you give us when
                you sign up, are automatically sent to the lender when you
                apply. That way, you don’t have to enter them again, making the
                process quicker and easier for you.
            </Text>
        </>
    )
}

export default ContentGuarantor
